<template>
  <el-menu class="navbar" mode="horizontal">
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <label class="admin-username">用户名</label>
        <i class="el-icon-caret-bottom"/>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
        <el-dropdown-item>
          <span style="display:block;">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span style="display:block;" >退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改密码" :visible.sync="changePwd" width="50%"  :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form class="change-password" :model="form" :rules="rules" ref="form" size="small" label-position="right" label-width="100px">
        <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPassword">
          <el-input type="password" v-model="form.oldPassword" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPassword">
          <el-input type="password" v-model="form.newPassword" auto-complete="off"></el-input>
          <p class="tip-msg">密码由6-20位数字与字母组成</p>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="rePassword">
          <el-input type="password" v-model="form.rePassword" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="dialog-btn" :loading="loading" type="primary">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-menu>
</template>

<script>

export default {
  components: {
  },
  data () {
    const validPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if(!checkPwd(value)) {
        callback(new Error('密码需由6-20位数字与字母组成'))
      } else {
        callback()
      }
    }
    const samePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次确认密码'))
      } else if(value != this.form.newPassword) {
        callback(new Error('两次密码不同，请重新确认'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      changePwd: false,
      closeon: false,
      form: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, trigger: 'blur', validator: validPassword }
        ],
        rePassword: [
          { required: true, trigger: 'blur', validator: samePassword }
        ]
      },
      formLabelWidth: '100px'
    }
  },
  computed: {
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    closeForm(formName) {
      this.changePwd = false
      this.resetForm(formName)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      .admin-username {
        padding: 0 5px;
        cursor: pointer;
      }
      .fa-user-circle {
        vertical-align: middle;
        font-size: 26px;
      }
      .el-icon-caret-bottom {
        /*position: absolute;
        right: -15px;
        top: 18px;*/
        vertical-align: middle;
        font-size: 14px;
      }
    }
  }
  .el-button--text {
    color: #606266;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/controlCenter/layout/components/ControlNavBar.vue